//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return {
            id:'',
            nickname:'',
            headpic:''
        }
    },
    mounted(){
        this.id = this.$route.query.id
        this.$http.post('/wuxingExchangeSelect',{id:this.$route.query.id}).then(res=>{
            if(res.body.code===0){
                this.id = JSON.parse(res.body.result[0].message).user_id
                this.$http.post('/wuxingUserinfo',{user_id:JSON.parse(res.body.result[0].message).user_id}).then((ress)=>{
                console.log(ress)
                if(ress.body.code===0){
                    this.nickname = ress.body.result[0].nickname
                    this.headpic = ress.body.result[0].headpic
                }
                })
            }
        })
    },
    methods:{
        linkTo(){
            this.$router.push('/recordList?id=' + this.id)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/my.vue